import ProductVariant from '@/zenky/interfaces/products/ProductVariant';
import ResourceNotifications from '@/zenky/resources/ResourceNotifications';
import Notification from '@/types/interfaces/Notification';

export default class ProductVariantNotifications extends ResourceNotifications {
  created(variant: ProductVariant): Notification {
    return this.createSuccessNotification(
      'Создание варианта',
      'Вариант был успешно создан.',
    );
  }

  creationFailed(err: any): Notification {
    return this.createFailedNotification(
      'Создание варианта',
      'Не удалось создать вариант.',
    );
  }

  updated(variant: ProductVariant): Notification {
    return this.createSuccessNotification(
      'Редактирование варианта',
      'Вариант был успешно сохранён.',
    );
  }

  updateFailed(variant: ProductVariant, err: any): Notification {
    return this.createFailedNotification(
      'Редактирование варианта',
      'Не удалось сохранить вариант.',
    );
  }

  deleted(variant: ProductVariant): Notification {
    return this.createSuccessNotification(
      'Удаление варианта',
      'Вариант был успешно удалён.',
    );
  }

  deleteFailed(variant: ProductVariant, err: any): Notification {
    return this.createFailedNotification(
      'Удаление варианта',
      'Не удалось удалить вариант.',
    );
  }
}
